/**
 * Normalize manager share-link API payload.
 * @param {unknown} raw
 * @returns {import("../types/club").ClubShareLinkResponse | null}
 */
export function unwrapClubShareLink(raw) {
  if (!raw || typeof raw !== "object") return null;
  if (raw.qrDataUrl && raw.shareUrl) return raw;
  const nested = raw.data;
  if (nested && typeof nested === "object" && nested.qrDataUrl) return nested;
  return null;
}

/**
 * Normalize public book-latest resolver payload.
 * @param {unknown} raw
 * @returns {import("../types/club").ClubBookLatestResponse | null}
 */
export function unwrapClubBookLatest(raw) {
  if (!raw || typeof raw !== "object") return null;
  if (raw.slug && (raw.redirectUrl || raw.websiteUrl)) return raw;
  const nested = raw.data;
  if (nested && typeof nested === "object" && nested.slug) return nested;
  return null;
}

/** @param {string} dataUrl @param {string} filename */
export function downloadQr(dataUrl, filename) {
  const href = String(dataUrl || "").trim();
  if (!href) return;
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
}
